import {
  AbsoluteLayout,
  AnchorLocations,
  BlankEndpoint,
  EVENT_CANVAS_CLICK,
  EVENT_DBL_CLICK,
  EVENT_DRAG_START,
  Edge,
  LassoPlugin,
  Node,
  OrthogonalConnector
} from "@jsplumbtoolkit/browser-ui";

import TabbedNode from "../../NodeLayouts/TabbedNode";

const SELECTABLE = "selectable";
const DEFAULT = "default";

export function CanvasConfigView(
  nodeClicked: (node: Node, doubleClick: boolean) => void,
  removeEdge: (edge: Edge) => void,
  canEdit: boolean = false
) {
  return {
    nodes: {
      [SELECTABLE]: {
        events: {
          dblclick: (params: { obj: Node }) => {
            nodeClicked(params.obj, true);
          },
          click: (params: { obj: Node }) => {
            nodeClicked(params.obj, false);
          },
          mousedown: (params: { obj: Node }) => {}
        }
      },

      [DEFAULT]: {
        parent: SELECTABLE,
        jsx: (ctx: any) => {
          return <TabbedNode ctx={ctx} data={ctx.data} />;
        }
      }
    },
    // There are two edge types defined - 'yes' and 'no', sharing a common
    // parent.

    // disappearing issue:
    //https://stackoverflow.com/questions/21638169/svg-line-with-gradient-stroke-wont-display-if-vertical-or-horizontal

    edges: {
      [DEFAULT]: {
        anchors: [AnchorLocations.Bottom, AnchorLocations.Top],
        endpoint: BlankEndpoint.type,
        connector: {
          type: OrthogonalConnector.type,
          options: { cornerRadius: 2, gap: 0, stub: 25, alwaysRespectStubs: false, slightlyWonky: false }
        },
        paintStyle: {
          strokeWidth: 3,
          stroke: "url(#linear)",
          outlineWidth: 6,
          outlineStroke: "transparent"
        }, //	paint style for this edge type.
        hoverPaintStyle: { strokeWidth: 5, stroke: "url(#linear)", outlineWidth: 6, outlineStroke: "transparent" },
        events: {
          [EVENT_DBL_CLICK]: (params: any) => {
            removeEdge(params.edge);
            // this.toolkit.removeEdge(params.edge)
          }
        }
      }
    },
    ports: {
      source: {
        maxConnections: 1,
        isSource: "true"
      },
      target: {
        isTarget: true,
        maxConnections: -1
      }
    }
  };
}

export function CanvasConfigRenderParams(canvasClicked: (e: Event) => void, shouldDrag: () => boolean) {
  return {
    // Layout the nodes using an absolute layout
    layout: {
      type: AbsoluteLayout.type
    },
    events: {
      // [EVENT_CONNECTION_EDIT]: (params:any) => {

      // },
      [EVENT_CANVAS_CLICK]: (e: Event) => {
        canvasClicked(e);
        // this.toolkit.clearSelection()

        // this.surface.setMode(SurfaceMode.SELECT)
        // // this.pathEditor.stopEditing()
      },
      [EVENT_DRAG_START]: (e: Event) => {
        return shouldDrag();
      }
    },
    lassoInvert: true,
    consumeRightClick: false,
    dragOptions: {
      filter: ".jtk-draw-handle, .node-action, .node-action i"
    },
    zoomToFit: false,
    plugins: [LassoPlugin.type],
    grid: {
      size: {
        w: 5,
        h: 5
      }
    },
    enableWheelZoom: false,
    zoomRange: [0.3, 2],
    padding: [2, 2],

    magnetize: {
      afterDrag: false
    }
  };
}
